import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { Users } from "./Users";
import UsersQueryNode from "./__generated__/UsersQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof Users> = {
  root: JSResource("Users", () =>
    import("./Users").then((module) => module.Users),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: UsersQueryNode,
          variables: {},
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
